<template>
  <h2 class="form-header">
    <slot />
  </h2>
</template>

<script>
export default {
  name: "QuestionHeader"
};
</script>

<style scoped lang="scss">
.form-header {
  font-size: 26px;
  margin: 40px 0px 20px 0px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  text-align: center;
  color: var(--primary-black);
  text-transform: var(--text-transform);

  @media (min-width: $large) {
    font-size: 32px;
  }
}
</style>